/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  IonAvatar,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonImg,
  IonPage,
  IonRow,
  IonText,
  IonToolbar,
} from "@ionic/react";
import logo from "../assets/icon-192x192.png";
import poster from "../assets/poster.jpeg";
import sms from "../assets/sms.jpg";
import success from "../assets/success.jpg";
import ticket from "../assets/ticket.png";
import token from "../assets/token.png";
import vote from "../assets/vote.png";
import { useWindowSize } from "../utils/WindowUtils";
import "./Home.scss";

const Home: React.FC = () => {
  const { isDesktop } = useWindowSize();

  return (
    <IonPage>
      <IonHeader className='ion-no-border'>
        <IonToolbar className='desktop-navbar' color='main-beige'>
          <IonRow className='ion-align-items-center'>
            <IonCol size='9' className='ion-no-padding ion-no-margin'>
              <IonRow className='ion-align-items-center'>
                <IonAvatar
                  style={{
                    width: "2.25rem",
                    height: "2.25rem",
                    marginLeft: "1rem",
                    marginRight: "1rem",
                    cursor: "pointer",
                  }}
                >
                  <img
                    src={logo}
                    alt='Logo'
                    onClick={() =>
                      window.open("https://wallofshame.io", "_blank")
                    }
                  />
                </IonAvatar>
                <IonText
                  style={{
                    fontWeight: "bold",
                    fontSize: "1.25rem",
                  }}
                >
                  <a
                    href='https://wallofshame.io'
                    target='_blank'
                    rel='noreferrer'
                    style={{ textDecoration: "none", color: "#ffffff" }}
                  >
                    Wall of Shame
                  </a>
                </IonText>
              </IonRow>
            </IonCol>
            <IonCol size='3'>
              <IonRow className='ion-justify-content-end ion-margin-end'>
                <IonText>
                  <a
                    href='https://wallofshame-landing.netlify.app'
                    target='_blank'
                    rel='noreferrer'
                    style={{ color: "#ffffff" }}
                  >
                    About
                  </a>
                </IonText>
              </IonRow>
            </IonCol>
          </IonRow>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonHeader collapse='condense'>
          <IonToolbar className='desktop-navbar' color='main-beige'>
            <IonRow className='ion-align-items-center'>
              <IonCol size='12' className='ion-no-padding ion-no-margin'>
                <IonRow className='ion-align-items-center'>
                  <IonAvatar
                    style={{
                      width: "2.25rem",
                      height: "2.25rem",
                      marginLeft: "1rem",
                      marginRight: "1rem",
                    }}
                  >
                    <img src={logo} alt='Logo' />
                  </IonAvatar>
                  <IonText
                    style={{
                      fontWeight: "bold",
                      fontSize: "1.25rem",
                    }}
                  >
                    <a
                      href='https://wallofshame.io'
                      target='_blank'
                      rel='noreferrer'
                      style={{ textDecoration: "none", color: "#ffffff" }}
                    >
                      Wall of Shame
                    </a>
                  </IonText>
                </IonRow>
              </IonCol>
            </IonRow>
          </IonToolbar>
          {!isDesktop && <div className='header-curve' />}
        </IonHeader>
        <IonGrid className='ion-padding main-content'>
          <IonRow
            className='ion-justify-content-start ion-align-items-center'
            style={{ margin: "1rem" }}
          >
            <IonText style={{ fontSize: "2.5rem", fontWeight: "500" }}>
              Wall of Shame STePs Voting Guide
            </IonText>
          </IonRow>
          <IonRow
            className='ion-justify-content-center ion-align-items-center'
            style={{ margin: "1rem" }}
          >
            <img src={poster} alt='Poster' />
          </IonRow>
          <IonRow className='ion-align-items-center ion-padding-top ion-padding-horizontal'>
            <IonText>
              Hello there! We are a group of students from the NUS School of
              Computing working on a project called{" "}
              <strong>Wall of Shame</strong>, and we are presenting our project
              at our school’s term project showcase called STePs on{" "}
              <strong>10th November</strong>. We would really appreciate it if
              you could give us a vote later from 3pm to 5.45pm.
            </IonText>
          </IonRow>
          <IonRow className='ion-align-items-center ion-padding-top ion-padding-horizontal'>
            <IonText style={{ fontWeight: "bold" }}>
              All voters will stand a chance to win S$10 cash prizes!
            </IonText>
          </IonRow>
          <IonRow
            className='ion-align-items-center'
            style={{ padding: "1rem" }}
          >
            <IonText>
              To enter the giveaway, send us a screenshot on our&nbsp;
              <a
                href='https://www.instagram.com/wallofshame.io/'
                target='_blank'
                rel='noreferrer'
              >
                Instagram
              </a>
              &nbsp;,or our&nbsp;
              <a
                href='https://www.facebook.com/wallofshame.io'
                target='_blank'
                rel='noreferrer'
              >
                Facebook
              </a>
              &nbsp;,or simply <strong>email</strong> your screenshot to&nbsp;
              <a
                href='#'
                onClick={() => {
                  window.open("https://wos.cs3216.2021@gmail.com");
                }}
              >
                wos.cs3216.2021@gmail.com
              </a>
              .
            </IonText>
          </IonRow>

          <IonRow className='ion-align-items-center ion-padding-horizontal ion-padding-bottom'>
            <IonText>
              If you’d like to try out our app, please visit{" "}
              <a target='_blank' href='https://wallofshame.io' rel='noreferrer'>
                here
              </a>
              !
            </IonText>
          </IonRow>
          <IonRow className='ion-align-items-center ion-padding-horizontal ion-padding-bottom'>
            <IonText>
              We will also be giving a presentation in STePs Channel B (
              <a
                target='_blank'
                rel='noopener noreferrer nofollow'
                href='https://nus-sg.zoom.us/j/87443878326?pwd=MGxESVZkQ05EeGU2MDBibVZsMHFGZz09'
              >
                Zoom link here
              </a>
              ) at 3.20pm on 10 November. Afterwards, we’ll be stationed at
              Breakout Room 28 in the same Zoom call to exhibit our project.
            </IonText>
          </IonRow>
          <IonRow className='ion-align-items-center ion-padding-horizontal ion-padding-bottom'>
            <IonText>
              If you’d like to vote for us (yay!!!), please read on.
            </IonText>
          </IonRow>
          <IonRow
            className='ion-align-items-center ion-padding-horizontal'
            style={{ marginTop: "0.5rem" }}
          >
            <IonText
              color='accent-beige'
              style={{ fontSize: "2rem", fontWeight: "600" }}
            >
              Register for a STePs Ticket
            </IonText>
          </IonRow>
          <IonRow
            className='ion-align-items-center'
            style={{ padding: "1rem" }}
          >
            <IonText style={{ fontWeight: "bold" }}>
              If you have already registered for a ticket, you may skip this
              section.
            </IonText>
          </IonRow>
          <IonRow className='ion-align-items-center'>
            <ol>
              <li style={{ marginBottom: "0.5rem" }}>
                <IonText>
                  Register for a 19th STePs ticket{" "}
                  <a
                    target='_blank'
                    rel='noopener noreferrer nofollow'
                    href='https://uvents.nus.edu.sg/event/19th-steps/registration'
                  >
                    here
                  </a>
                  .&nbsp;
                </IonText>

                <IonText>
                  When filling the form, choose “Late Registration”.
                </IonText>

                <IonRow className='ion-padding-vertical'>
                  <IonImg src={ticket} alt='Registering for a STePs ticket' />
                </IonRow>
              </li>
              <li style={{ marginBottom: "0.5rem" }}>
                <IonText>
                  When you complete the form, you should receive a SMS at the
                  phone number you registered with.
                </IonText>
                <IonRow className='ion-padding-vertical ion-justify-content-center'>
                  <IonImg
                    src={sms}
                    alt='Confirmation SMS with Secret Voter ID'
                    style={{ maxWidth: "365px" }}
                  />
                </IonRow>
              </li>
              <li style={{ marginBottom: "0.5rem" }}>
                <IonText>
                  Take note of what your secret VOTER-ID is. You’ll need to use
                  it to vote later.
                </IonText>
              </li>
            </ol>
          </IonRow>
          <IonRow
            className='ion-align-items-center ion-padding-horizontal'
            style={{ marginTop: "0.5rem" }}
          >
            <IonText
              color='accent-beige'
              style={{ fontSize: "2rem", fontWeight: "600" }}
            >
              Voting for Wall of Shame (3pm to 5.45pm)
            </IonText>
          </IonRow>
          <IonRow
            className='ion-align-items-center'
            style={{ padding: "1rem" }}
          >
            <IonText style={{ fontWeight: "bold" }}>
              <strong>Note:</strong> Voting will only{" "}
              <strong>start after 3pm</strong>, and will{" "}
              <strong>end by 5.45pm</strong>. Please cast your votes before
              5.45pm!
            </IonText>
          </IonRow>
          <IonRow>
            <ol>
              <li style={{ marginBottom: "0.5rem" }}>
                <IonText>
                  Visit the{" "}
                  <a
                    target='_blank'
                    rel='noopener noreferrer nofollow'
                    href='https://uvents.nus.edu.sg/event/19th-steps/vote'
                  >
                    page to vote for projects
                  </a>
                  . You do not have to log-in. All you need is your voter-id
                  from the registration SMS.
                </IonText>
              </li>
              <li style={{ marginBottom: "0.5rem" }}>
                <IonText>
                  In the page, look for <strong>CS3216-05</strong>, that is our
                  project. Vote for <strong>Wall of Shame</strong> by clicking
                  on “1st”.
                </IonText>

                <IonRow className='ion-padding-vertical ion-justify-content-center'>
                  <IonImg
                    src={vote}
                    alt='Vote for Wall of Shame'
                    style={{ maxWidth: "365px" }}
                  />
                </IonRow>
              </li>
              <li style={{ marginBottom: "0.5rem" }}>
                <IonText>
                  You will also need to vote for two other teams for “2nd” and
                  “3rd”. Just choose two other projects that you fancy (or just
                  choose them randomly, it’s up to you).
                </IonText>
              </li>
              <li style={{ marginBottom: "0.5rem" }}>
                <IonText>
                  After selecting all three projects (including Wall of Shame),
                  scroll to the bottom of the page and fill in your voter token.
                  This is the same as the VOTER-ID you received in the SMS,
                  after you’ve registered.
                </IonText>

                <IonRow className='ion-padding-vertical ion-justify-content-center'>
                  <IonImg src={token} alt='Token' />
                </IonRow>
              </li>
              <li style={{ marginBottom: "0.5rem" }}>
                <IonText>Submit your vote!</IonText>

                <IonRow className='ion-padding-vertical ion-justify-content-center'>
                  <IonImg src={success} alt='Successful' />
                </IonRow>
              </li>
              <li style={{ marginBottom: "0.5rem" }}>
                <IonText>
                  That’s it! Thank you for voting for Wall of Shame! We will
                  announce the prize winners on our&nbsp;
                  <a
                    href='https://www.instagram.com/wallofshame.io/'
                    target='_blank'
                    rel='noreferrer'
                  >
                    Instagram
                  </a>
                  &nbsp;and&nbsp;
                  <a
                    href='https://www.facebook.com/wallofshame.io'
                    target='_blank'
                    rel='noreferrer'
                  >
                    Facebook
                  </a>
                  ! Keep an eye out!
                </IonText>
              </li>
            </ol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default Home;
